<div class="step-card-container">
  <div class="step-card">
    <div class="step-card-left">
      <img src="{{ card?.image }}" alt="" />
    </div>
    <div class="step-card-right">
      <h6 class="step-card-title">{{ card?.title }}</h6>
      <p class="step-card-copy text-wrap text-left">{{ card?.copy }}</p>
    </div>
  </div>
</div>
